import React from 'react';
import { Button, Col, Input, Modal, ModalBody, Row } from 'reactstrap';

import FriendProfileContainer from '../../../containers/FriendProfileContainers/friendProfileContainer';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import ModalBase from '../../ModalBase/ModalBase';
import MyFriendItem from './MyFriendItem';

class MyFriends extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removeFriendPopUp: false,
      addFriendStep: 1,
      friendEmail: '',
      friendEmailValid: null,
      moreFriends: true,
      friends: [],
      friendToRemove: null,
      friendProfileOpened: false,
      friendProfileId: null,
    };
  }

  componentDidMount() {
    this.props.loadFriends(0, 6);
  }

  loadMoreFriends = () => {
    this.props.loadFriends(this.props.friends.length, 6);
  };

  /** **** REMOVE FRIENDS ***** */

  openRemoveFriendPopUp = (id) => {
    this.setState({ friendToRemove: id, removeFriendPopUp: true });
  };

  toggleFriendPopUp = () => {
    this.setState({ removeFriendPopUp: !this.state.removeFriendPopUp });
  };

  removeFriend = () => {
    this.props.removeFriend(this.state.friendToRemove);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.removeFriendSuccess) {
      this.props.setRemoveFriendSuccess(false);
      this.setState({ friendToRemove: null, removeFriendPopUp: false });
    }

    if (nextProps.removeFriendMessage.text !== '') {
      this.hideMessage(this.props.setRemoveFriendMessage);
    }

    if (nextProps.sendFriendsRequestMessage.text !== '') {
      this.hideMessage(this.props.setSendFriendRequestMessage);
    }
  }

  hideMessage = (functionParam) => {
    setTimeout(() => {
      functionParam({ type: 'success', text: '' });
    }, 3000);
  };

  componentWillUnmount() {
    this.props.resetFriendsObject();
    this.props.setTotalFriendsCount(0);
  }

  /** *** ADD FRIENDS *** */

  sendFriendRequest = () => {
    const emailValid = document.querySelector('#email').validity.valid;

    if (emailValid) {
      this.props.sendFriendsRequest(this.state.friendEmail);
      this.setState({ friendEmailValid: true });
      this.props.setSendFriendRequestMessage({ type: 'error', text: '' });
    } else {
      this.props.setSendFriendRequestMessage({
        type: 'error',
        text: 'Invalid email address',
      });
      this.setState({ friendEmailValid: false });
    }
  };

  sendAnotherFriendRequest = () => {
    this.props.setSendFriendRequestSuccess(false);
    this.setState({
      friendEmail: '',
      friendEmailValid: null,
    });
  };

  updateFriendEmail = (e) => {
    this.setState({ friendEmail: e.currentTarget.value });
  };

  openFriendProfile = (value, friendId) => {
    this.setState({ friendProfileOpened: false, friendProfileId: friendId });
  };

  render() {
    return (
      <div
        className={
          this.props.totalFriendsCount > this.props.friends.length
            ? 'my-profile-component my-friends disabled-questions'
            : 'my-profile-component my-friends disabled-questions extra-padding'
        }
      >
        <Row className="header d-flex flex-row justify-content-between">
          <div className="title">My Friends</div>
        </Row>

        {this.props.friends.length > 0 ? (
          <div>
            <Row className="body">
              <Col sm={12} md={6} id="friends">
                {this.props.friends !== undefined
                  ? this.props.friends.map((friend, index) => (
                      <MyFriendItem
                        key={friend.id}
                        {...friend}
                        openRemoveFriendPopUp={this.openRemoveFriendPopUp}
                        openFriendProfile={this.openFriendProfile}
                      />
                    ))
                  : ''}
              </Col>
              <Col sm={12} md={6}>
                {!this.props.sendFriendsRequestSuccess ? (
                  <div>
                    <p className="font-size-2 mt-2 mt-sm-0">Add friends</p>
                    <Input
                      className="my-profile-input"
                      id="email"
                      type="email"
                      placeholder="Enter Friend's Email"
                      value={this.state.friendEmail}
                      onChange={(e) => this.updateFriendEmail(e)}
                    />
                    <Button
                      color="primary"
                      block
                      onClick={this.sendFriendRequest}
                      className="send-friends-request-button"
                    >
                      {this.props.sendFriendsRequestWaiting ? (
                        <CircularLoading className="loading-gif-waiting button-gif" />
                      ) : (
                        <span>SEND FRIEND REQUEST</span>
                      )}
                    </Button>
                    {this.props.removeFriendMessage.type === 'success' &&
                      this.props.removeFriendMessage.text !== '' && (
                        <div className="message-success remove-message">
                          {this.props.removeFriendMessage.text}
                        </div>
                      )}
                    {this.props.sendFriendsRequestMessage.text !== '' &&
                      this.props.sendFriendsRequestMessage.type === 'error' && (
                        <span className="message-error">
                          {this.props.sendFriendsRequestMessage.text}
                        </span>
                      )}
                  </div>
                ) : (
                  <div className="d-flex flex-column align-items-center">
                    <i className="icon-email bigIcon" />
                    <h4 className="mt-2">Friend Request Sent!</h4>
                    <Button
                      color="primary"
                      block
                      onClick={this.sendAnotherFriendRequest}
                      className="send-friends-request-button"
                    >
                      SEND ANOTHER
                    </Button>
                  </div>
                )}
              </Col>
            </Row>
            {this.props.totalFriendsCount > this.props.friends.length &&
            (!this.props.loadFriendsWaiting ||
              this.props.friends.length > 0) ? (
              <Row className="borderTop mt-3">
                <Col sm={12}>
                  <Button
                    color="link"
                    block
                    className="link-secondary"
                    onClick={this.loadMoreFriends}
                  >
                    {this.props.loadFriendsWaiting ? (
                      <CircularLoading className="load-more-gif" />
                    ) : (
                      <span>LOAD MORE</span>
                    )}
                  </Button>
                </Col>
              </Row>
            ) : null}
            <FriendProfileContainer
              isOpen={this.state.friendProfileOpened}
              friendId={this.state.friendProfileId}
              openFriendProfile={this.openFriendProfile}
            />
          </div>
        ) : !this.props.loadFriendsWaiting ? (
          <Row className="body">
            {!this.props.sendFriendsRequestSuccess ? (
              <Col
                sm={12}
                md={12}
                className="d-flex flex-column align-items-center initialFriend"
              >
                <p className="font-size-2 mt-2 mt-sm-0">
                  Add Friends to get started
                </p>
                <Input
                  className="my-profile-input"
                  placeholder="Enter Friend's Email"
                  onChange={(e) => this.updateFriendEmail(e)}
                  value={this.state.friendEmail}
                  id="email"
                  type="email"
                />
                <Button color="primary" block onClick={this.sendFriendRequest}>
                  SEND FRIEND REQUEST
                </Button>
                {this.props.sendFriendsRequestMessage.text !== '' &&
                  this.props.sendFriendsRequestMessage.type === 'error' && (
                    <span className="message-error">
                      {this.props.sendFriendsRequestMessage.text}
                    </span>
                  )}
              </Col>
            ) : (
              <div className="col-12 d-flex flex-column align-items-center mb-3">
                <i className="icon-email bigIcon" />
                <h4 className="mt-2">Friend Request Sent!</h4>
                <Button
                  color="primary"
                  block
                  onClick={this.sendAnotherFriendRequest}
                >
                  SEND ANOTHER
                </Button>
              </div>
            )}
          </Row>
        ) : (
          <Row className="body-loading">
            <div className="col-12 d-flex flex-column align-items-center mb-3">
              <CircularLoading className="loading-gif-waiting main-gif" />
            </div>
          </Row>
        )}

        <ModalBase
          isOpen={this.state.removeFriendPopUp}
          toggle={this.toggleFriendPopUp}
          className="removeFriend modal-dialog-centered"
          removeFriendMessage={this.props.removeFriendMessage}
          header={<>Remove Friend?</>}
          body={
            <>
              {this.props.removeFriendMessage.type === 'error' &&
                this.props.removeFriendMessage.text !== '' && (
                  <div className="message-error remove-message">
                    {this.props.removeFriendMessage.text}
                  </div>
                )}

              <button
                className="btn modal-base-btn secondary"
                onClick={this.toggleFriendPopUp}
              >
                CANCEL
              </button>
              <button
                className="btn modal-base-btn primary"
                onClick={this.removeFriend}
              >
                CONFIRM
              </button>
            </>
          }
        />
      </div>
    );
  }
}

export default MyFriends;
